import type { NotificationSettingsEntity } from '../entities/NotificationSettingsEntity.js';
import type { INotificationSettingsRepository } from '../repositories/INotificationSettingsRepository.js';

interface Deps { notificationSettingsRepository: INotificationSettingsRepository; }

export function createGetNotificationSettingsUseCase({ notificationSettingsRepository }: Deps) {
  return function getNotificationSettings(userId: string): Promise<NotificationSettingsEntity> {
    return notificationSettingsRepository.get(userId);
  };
}

export function createUpdateNotificationSettingsUseCase({ notificationSettingsRepository }: Deps) {
  return function updateNotificationSettings(settings: NotificationSettingsEntity): Promise<void> {
    return notificationSettingsRepository.update(settings);
  };
}
